import React, { Component } from "react";
import { connect } from "react-redux";
import { recommendation } from "../../models";
import { SliderNavigation } from "../Slider";
import { Translation } from "react-i18next";
import { ROOT } from "../../constants";
import "../../css/syte.css";

export class Recommendation extends Component {
  element = null;
  able = true;

  componentDidMount() {
    const { type } = this.props;
    const url = window.location.pathname;
    const cbu = url.substring(url.lastIndexOf("/") + 1);
    this.props.fetchRecommendation(cbu, type);
    window.addEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const elementTop = this.element ? this.element.offsetTop : 0;
    const scrolling = window.pageYOffset;
    const screenHeight = window.innerHeight;
    // 推薦商品
    if (scrolling > elementTop - screenHeight && this.able) {
      this.able = false;
      if (window.syteDataLayer) {
        window.syteDataLayer.push({
          name: "fe_personalization_show_layout",
          tag: "personalization"
        });
        window.removeEventListener("scroll", this.handleScroll);
      }
    }
  };

  handleCard = (e, data, index) => {
    // 取消<a>預設值行為
    e.preventDefault();
    const { type } = this.props;
    const { productCode, name, name2, price, originalPrice } = data;
    // syte追蹤碼
    if (window.syteDataLayer) {
      window.syteDataLayer.push({
        name: "fe_offer_click",
        tag: "personalization",
        sku: productCode,
        position: index + 1
      });
    }
    // dataLayer事件
    const _price = price ? price.replace("HK$", "").replaceAll(",", "") : 0;
    const _originalPrice = originalPrice
      ? originalPrice.replace("HK$", "").replaceAll(",", "")
      : 0;
    const _discount = _originalPrice - _price;
    const dashFirstIndex = productCode.indexOf("-");
    const dashSecondIndex = productCode.indexOf("-", dashFirstIndex + 1);
    const _item_category = productCode.substring(
      dashFirstIndex - 1,
      dashFirstIndex
    );
    const _item_category2 = productCode.substring(
      dashFirstIndex + 1,
      dashSecondIndex
    );
    const _item_category3 = productCode.substring(
      dashSecondIndex + 1,
      productCode.length
    );
    const event = "click_YMAL_PDP_widget_insider";
    const pushData = {
      event: event,
      ecommerce: {
        currency: "HKD",
        items: [
          {
            item_name: name2,
            item_id: productCode,
            price: _price,
            discount: _discount,
            item_brand: name,
            item_category: _item_category,
            item_category2: _item_category2,
            item_category3: _item_category3,
            quantity: 1
          }
        ]
      }
    };
    if (window.dataLayer) {
      window.dataLayer.push(pushData);
    }
    // 等待0.5秒後執行換頁;
    const url = e.target.href;
    setTimeout(() => {
      window.location = url;
    }, 1000);
  };

  render() {
    const { type, products } = this.props;
    return (
      <div id={`recommendation_${type}`}>
        {products && products.length > 0 && (
          <>
            <div
              className="sectionTitle-wrap"
              ref={element => {
                this.element = element;
              }}
            >
              <p className="sectionTitle">
                <Translation>
                  {t => <>{t("section.recommendation")}</>}
                </Translation>
              </p>
            </div>
            <SliderNavigation
              name={`recommendation_${type}_wrap`}
              recentlyViewed={products}
            >
              {products.map((data, index) => (
                <div
                  className="swiper-slide"
                  key={index}
                  data-scarabitem={data.cciId}
                >
                  <div className="pdt_block">
                    <a
                      className="pdtImg_link"
                      href={`${ROOT}${data.productDetailUrl}`}
                      style={{
                        backgroundImage: `url(${data.imageUrl})`
                      }}
                      onClick={e => {
                        this.handleCard(e, data, index);
                      }}
                    >
                      <div
                        className="pdtImghover_container"
                        style={{
                          backgroundImage: `url(${data.imageUrl2})`
                        }}
                      />
                    </a>
                    <div className="desc_wrap">
                      {/* <AddToFav pdtId={data.productCode} /> */}
                      <div className="collectionName">{data.name}</div>
                      <div className="name">{data.name2}</div>
                      {data.saleType &&
                      [
                        "normal",
                        "display-show-price",
                        "display-inventory"
                      ].includes(data.saleType) ? (
                        data.price !== data.originalPrice ? (
                          <React.Fragment>
                            <div
                              className="product-orignal-price"
                              style={{ fontSize: "12px" }}
                            >
                              {data.originalPrice}
                            </div>
                            <div className="price">{data.price}</div>
                          </React.Fragment>
                        ) : (
                          <div className="price">{data.originalPrice}</div>
                        )
                      ) : data.saleType === "display" ? null : null}
                    </div>
                  </div>
                </div>
              ))}
            </SliderNavigation>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = () => {
  return {
    fetchRecommendation: (cbu, type) =>
      recommendation.actions.fetchRecommendation(cbu, type)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Recommendation);
